"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestId = void 0;
/**
 * Test IDs used in sharing-panel component.
 */
let TestId = exports.TestId = /*#__PURE__*/function (TestId) {
  /**
   * Caption visible when captionText property was set.
   */
  TestId["Caption"] = "caption";
  /**
   * Copy link content root element.
   */
  TestId["CopyLinkContent"] = "copy-link-content";
  /**
   * Particular social sharing icon in panel.
   * The unique vendor value is present in the data-vendor attribute on each icon.
   */
  TestId["Icon"] = "icon";
  /**
   * Icons section containing a set of particular social sharing icons.
   */
  TestId["Icons"] = "icons";
  /**
   * Sharing panel root element.
   */
  TestId["Root"] = "root";
  return TestId;
}({});
